if (!customElements.get('link-filters')) {
  class LinkFilters extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.historyChangeHandler);

      if (this.breakpointChangeHandler) {
        window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }
    }

    init() {
      this.results = document.getElementById('filter-results');
      this.activeFilterClass = 'link__active-filter';
      this.filters = this.querySelectorAll('.link_filter');

      this.addListeners();
    }

    addListeners() {
      this.filters.forEach(filter => filter.addEventListener('click', this.handleFiltersClick.bind(this)));
      this.filters.forEach(filter => filter.addEventListener('tap', this.handleFiltersClick.bind(this)));
      this.historyChangeHandler = this.historyChangeHandler || this.handleHistoryChange.bind(this);
      window.addEventListener('popstate', this.historyChangeHandler);
    }
    
    /**
     * Handles 'click' events on the filters.
     * @param {object} evt - Event object.
      */
    handleFiltersClick(evt) {
      const { target } = evt;
      
      console.log('target', target);
      
      evt.preventDefault();
      let href = target.href || target.closest(".link_filter").href;
       console.log('href', href);
      
      // remove active class from all filter buttons
      const activeFilter = document.querySelector(`.${this.activeFilterClass}`);
      activeFilter.classList.remove(this.activeFilterClass);

      target.closest('.link-filter').classList.add(this.activeFilterClass);

      this.applyFilters(href, evt); 
    }

    /**
     * Handles history changes (e.g. back button clicked).
     * @param {object} evt - Event object.
     */
    handleHistoryChange(evt) {
      if (evt.state !== null) {
        let searchParams = '';

        if (evt.state && evt.state.searchParams) {
          ({ searchParams } = evt.state);
        }

        this.applyFilters(searchParams, null, false);
      }
    }

    /**
     * Fetches the filtered/sorted page data and updates the current page.
     * @param {string} searchParams - Filter/sort search parameters.
     * @param {object} evt - Event object.
     * @param {boolean} [updateUrl=true] - Update url with the selected options.
     */
    async applyFilters(url, evt, updateUrl = true) {
      const customPagination = document.querySelector('custom-pagination');
      if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'true';

      this.results.classList.add('is-loading');

      // Fetch filtered products markup.
      const response = await fetch(`${url == 'all-products' ? window.location.pathname : url}`);

      if (response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        // Update the results.
        this.results.innerHTML = tmpl.content.getElementById('filter-results').innerHTML;

        // Reinitialize lazyload images after filters applied.
        if (typeof initLazyImages === 'function') initLazyImages();

        // Reinitialize any custom pagination
        if (customPagination && customPagination.reload) customPagination.reload();

        // Update the URL.
        if (updateUrl) LinkFilters.updateURL(url);

        // Renable infinite scroll
        if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'false';

        // Broadcast the update for anything else to hook into
        document.dispatchEvent(new CustomEvent('on:link-filters:updated'), { bubbles: true });
      }

      this.results.classList.remove('is-loading');
    }

    /**
     * Updates the url with the current filter/sort parameters.
     * @param {string} searchParams - Filter/sort parameters.
     */
    static updateURL(searchParams) {
      console.log('window.location.pathname', window.location.pathname)
      console.log(searchParams)
      console.log('window.location', window.location)
      window.history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
      );
    }
  }

  customElements.define('link-filters', LinkFilters);
}
